import doctorModule from "./module";

export default doctorModule.reducer;
